(() => {
  const setup = () => document.querySelectorAll('.tasha-native-hero:not([data-ready])').forEach(track => {
    track.dataset.ready = 'true';
    const wrapper = track.closest('.SlideshowWrapper');
    const slides = Array.from(track.children);
    const dots = Array.from(wrapper.querySelectorAll('[data-tasha-slide]'));
    const position = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
    const update = () => {
      const current = position();
      slides.forEach((slide, index) => {
        const hidden = String(index !== current);
        if (slide.getAttribute('aria-hidden') !== hidden) slide.setAttribute('aria-hidden', hidden);
        slide.inert = index !== current;
      });
      dots.forEach((dot, index) => {
        if (index === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    const go = index => {
      const next = (index + slides.length) % slides.length;
      track.scrollTo({ left: next * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    wrapper.querySelectorAll('[data-tasha-direction]').forEach(button => button.addEventListener('click', () => go(position() + Number(button.dataset.tashaDirection))));
    dots.forEach(dot => dot.addEventListener('click', () => go(Number(dot.dataset.tashaSlide))));
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : position() + (event.key === 'ArrowRight' ? 1 : -1));
    });
    track.addEventListener('scroll', update, { passive: true });
    update();
  });
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
